module.exports = __webpack_public_path__ + "img/3481e77.svg";